(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/retailer-login/assets/javascripts/change-password-form.js') >= 0) return;  svs.modules.push('/components/components/retailer-login/assets/javascripts/change-password-form.js');
"use strict";


const _svs = svs,
  events = _svs.events;
const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  userSession = _svs$core.userSession;
const getSiblingByClass = (elem, className) => [].filter.call(elem.parentElement.children, child => child.classList.contains(className)).pop();
function RetailerChangePassword(_ref) {
  let returnUrl = _ref.returnUrl;
  const formElem = document.querySelector('.js-retailer-change-password-form');
  if (!formElem) {
    throw Error('Form element not found.');
  }
  const ui = {
    cancelBtn: formElem.querySelector('[name=cancel]'),
    formErrors: Array.prototype.slice.call(formElem.querySelectorAll('.js-error-message')),
    newPwd1: formElem.querySelector('[name=newPassword1]'),
    newPwd2: formElem.querySelector('[name=newPassword2]'),
    oldPwd: formElem.querySelector('[name=oldPassword]'),
    pwd2Error: formElem.querySelector('[name=newPassword2]~.info-message'),
    submitBtn: formElem.querySelector('[type=submit]')
  };
  const validatePasswords = () => {
    const pwdsMatch = ui.newPwd1.value === ui.newPwd2.value;
    ui.submitBtn.disabled = !pwdsMatch;
    ui.pwd2Error.innerText = pwdsMatch ? '' : 'Lösenorden stämmer inte överens';
  };
  ui.newPwd2.addEventListener('keyup', () => {
    validatePasswords({
      formElem
    });
  });
  const clearFormErrors = () => {
    ui.formErrors.forEach(elem => {
      elem.innerText = '';
      elem.parentElement.classList.remove('error');
    });
  };
  const showFormError = _ref2 => {
    let formField = _ref2.formField,
      message = _ref2.message;
    formField.parentElement.classList.add('error');
    const errElem = getSiblingByClass(formField, 'js-error-message');
    errElem.innerHTML = message;
  };
  const showDialog = function () {
    let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$message = _ref3.message,
      message = _ref3$message === void 0 ? 'Var vänlig försök igen senare.' : _ref3$message,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? 'Tekniskt fel' : _ref3$title;
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.NEUTRAL,
      type: svs.ui.dialog.type.ERROR,
      title,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: message
      }],
      actions: [{
        title: 'Stäng'
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  const onSubmit = event => {
    event.preventDefault();
    const oldPassword = ui.oldPwd.value;
    const newPassword = ui.newPwd1.value;
    clearFormErrors();
    events.publish('/loader/show');
    jupiter.put({
      path: '/user/2/password',
      data: {
        oldPassword,
        newPassword
      }
    }, () => RetailerChangePassword.redirect(returnUrl), _ref4 => {
      let responseJSON = _ref4.responseJSON;
      return onLoginError(responseJSON);
    });
    const onLoginError = function () {
      let _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        error = _ref5.error;
      events.publish('/loader/hide');
      switch ("".concat(error.code).replace(/\s/, '')) {
        case '6243':
          showFormError({
            fieldName: 'oldPassword',
            formField: ui.oldPwd,
            message: 'Fel lösenord'
          });
          break;
        case '6125':
          showFormError({
            fieldName: 'newPassword1',
            formField: ui.newPwd1,
            message: 'Lösenordet är för kort'
          });
          break;
        default:
          showDialog();
      }
    };
  };
  formElem.addEventListener('submit', onSubmit);
  ui.cancelBtn.addEventListener('click', () => {
    userSession.logout();
  });
}
RetailerChangePassword.redirect = url => {
  window.location.assign(url);
};
svs.components.RetailerChangePassword = RetailerChangePassword;

 })(window);